export function loadingView(message: string, percent = 10, onLogout?: () => void): HTMLElement {
  const boundedPercent = Math.min(100, Math.max(0, percent));
  const element = document.createElement('main');
  element.className = 'loading-view';
  element.innerHTML = `
    <div class="legacy-loading" role="status" aria-live="polite">
      <p class="legacy-loading__label">Loading...</p>
      <div class="legacy-loading__bar" aria-hidden="true">
        <img class="legacy-loading__bar-bottom" src="/legacy/startup/progbar_bottom.png" alt="" />
        <span class="legacy-loading__bar-progress">
          <img src="/legacy/startup/progbar_top.png" alt="" />
        </span>
      </div>
      <p class="legacy-loading__detail"></p>
    </div>
  `;
  const progress = element.querySelector<HTMLElement>('.legacy-loading__bar-progress');
  if (progress !== null) progress.style.width = `${String(boundedPercent)}%`;
  const detail = element.querySelector<HTMLElement>('.legacy-loading__detail');
  if (detail !== null) detail.textContent = message;
  if (onLogout !== undefined) {
    const logout = document.createElement('button');
    logout.className = 'loading-view__logout';
    logout.type = 'button';
    logout.textContent = 'Logout';
    logout.setAttribute('aria-label', 'Logout');
    logout.title = 'Logout';
    logout.addEventListener('click', onLogout);
    element.append(logout);
  }
  return element;
}
